export {
  notEmpty,
  isSet,
  lessThanMaxLength,
  validName,
  validEmail,
  validStreetAddress,
  validZipcode,
} from "../validators";

export type TestResultShape = {
  message: string;
  blockSubmit: boolean;
};
type TestGeneratedFunc<T> = (val: NonNullable<T>) => TestResultShape;

export const test =
  <T>(
    testFunc: (val: NonNullable<T>) => boolean,
    message: string,
    shouldBlockSubmit = true,
  ) =>
  (val: T): TestResultShape => ({
    message: !testFunc(val as NonNullable<T>) ? message : "",
    blockSubmit: Boolean(shouldBlockSubmit && !testFunc(val as NonNullable<T>)),
  });

type TestReturnObject<TFormValues extends object> = {
  [K in keyof TFormValues]?: TestGeneratedFunc<TFormValues[K]>[];
};
export type ValidationMapperFunc<TFormValues extends object> = (
  data: TFormValues,
) => TestReturnObject<TFormValues>;

export type FormErrorShape<TFormValues extends object> = {
  [K in keyof TFormValues]?: TestResultShape;
};

export const validate = <TFormValues extends object>(
  formData: TFormValues,
  validationMapper: ValidationMapperFunc<TFormValues>,
) => {
  const testObject = validationMapper(formData);
  const formErrors: FormErrorShape<TFormValues> = {};
  for (const form_key in testObject) {
    if (!testObject[form_key]) continue;
    for (const test of testObject[form_key]) {
      const formValue = formData[form_key] as NonNullable<
        TFormValues[typeof form_key]
      >;
      const testResult = test(formValue);
      formErrors[form_key] = testResult;
      if (testResult.message.length > 0) {
        break;
      }
    }
  }

  return formErrors;
};
